import { useState } from "react";
import { Mail, Send } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useT } from "@/lib/i18n";

const inp = "w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm outline-none focus:border-[#5aa469]";

export function ContactSection() {
  const { t } = useT();
  const [f, setF] = useState({ name: "", email: "", restaurant: "", phone: "", message: "", website: "" });
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await api.post("/contact", f); setSent(true); } catch (ex) { toast.error(errMsg(ex)); } finally { setBusy(false); }
  };
  return (
    <section id="contact" data-testid="contact-section" className="mx-auto max-w-6xl px-6 py-20">
      <div className="grid gap-10 rounded-3xl border border-slate-100 bg-[#f6faf6] p-8 lg:grid-cols-[1fr_1.2fr] lg:p-12">
        <div>
          <p className="text-sm font-semibold text-[#4a8a56]">{t("contact_kicker")}</p>
          <h2 className="mt-2 font-heading text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">{t("contact_title")}</h2>
          <p className="mt-4 text-slate-600">{t("contact_sub")}</p>
          <a href="mailto:emergeresoftware@gmail.com" data-testid="contact-email-link" className="mt-6 inline-flex items-center gap-2 font-semibold text-[#4a8a56]"><Mail size={18} />emergeresoftware@gmail.com</a>
        </div>
        {sent ? (
          <div data-testid="contact-success" className="flex flex-col items-start justify-center rounded-2xl bg-white p-8"><p className="font-heading text-xl font-bold text-slate-900">{t("contact_sent_title")}</p><p className="mt-2 text-sm text-slate-600">{t("contact_sent_desc")}</p></div>
        ) : (
          <form onSubmit={submit} className="grid gap-3 sm:grid-cols-2">
            <input data-testid="contact-name" required minLength={2} placeholder={t("name")} className={inp} value={f.name} onChange={set("name")} />
            <input data-testid="contact-email" required type="email" placeholder={t("email")} className={inp} value={f.email} onChange={set("email")} />
            <input data-testid="contact-restaurant" placeholder={t("restaurant_name")} className={inp} value={f.restaurant} onChange={set("restaurant")} />
            <input data-testid="contact-phone" placeholder={t("phone")} className={inp} value={f.phone} onChange={set("phone")} />
            <input tabIndex={-1} autoComplete="off" className="hidden" value={f.website} onChange={set("website")} />
            <textarea data-testid="contact-message" required minLength={10} rows={4} placeholder={t("contact_message_ph")} className={`${inp} sm:col-span-2`} value={f.message} onChange={set("message")} />
            <button data-testid="contact-submit" disabled={busy} className="inline-flex items-center justify-center gap-2 rounded-full bg-[#5aa469] px-7 py-3 font-semibold text-white hover:bg-[#4a8a56] disabled:opacity-60 sm:col-span-2 sm:justify-self-start">{busy ? "…" : t("contact_send")} <Send size={16} /></button>
          </form>
        )}
      </div>
    </section>
  );
}
